import MuxVideo from '@/components/MuxVideo'

interface ProjectVideoProps {
	video: any
}

export default function ProjectVideo({ video }: ProjectVideoProps) {
	return (
		<div className="relative w-full h-full" data-playback-id={video?.asset?.playbackId}>
			<MuxVideo
				className={`absolute inset-0 block w-full h-full object-cover`}
				playbackId={video?.asset?.playbackId}
				autoplay={true}
				loop={true}
				showAudioToggle={true}
			/>
		</div>
	)
}
